import * as types from './types';
import { loading, handleErrorException, success } from 'State/actions';

export const writeBalanceToZero = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ZERO_NEGATIVE_BALANCES_LOADING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        'Student/WriteZeroAccountBalance',
        model
      );
      dispatch(setSaveSuccessful(true));
    } catch (error) {
      const writeError = {
        Title: 'Error',
        Message:
          'An error occured while attempting to write the changes. Please try again.',
      };
      dispatch(
        handleErrorException(
          error,
          types.ZERO_OUT_BALANCES_SET_ERROR,
          writeError
        )
      );
    }
    dispatch(loading(types.ZERO_NEGATIVE_BALANCES_LOADING, false));
  };
};

export const getNegativeAccounts = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ZERO_NEGATIVE_BALANCES_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Student/GetNegativeAccounts',
        model
      );
      dispatch(
        success(
          types.ZERO_OUT_NEGATIVE_BALANCES_GET_NEGATIVE_BALANCES,
          response.data.Data
        )
      );
    } catch (error) {
      const writeError = {
        Title: 'Error',
        Message:
          'An error occured while attempting to write the changes. Please try again.',
      };
      dispatch(
        handleErrorException(
          error,
          types.ZERO_OUT_BALANCES_SET_ERROR,
          writeError
        )
      );
    }
    dispatch(loading(types.ZERO_NEGATIVE_BALANCES_LOADING, false));
  };
};

export const setSaveSuccessful = value => {
  return {
    type: types.ZERO_NEGATIVE_BALANCES_SET_SAVE_SUCCESSFULL,
    payload: value,
  };
};

export const clearError = () => {
  return {
    type: types.ZERO_NEGATIVE_BALANCE_CLEAR_ERROR,
  };
};

export const setNoDataDialog = data => {
  return {
    type: types.ZERO_NEGATIVE_BALANCES_NO_DATA_DIALOG,
    payload: data,
  };
};

export const setDialog = data => {
  return {
    type: types.ZERO_NEGATIVE_BALANCES_DIALOG,
    payload: data,
  };
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/zeroNegativeBalance/actions.js